module.exports = __webpack_public_path__ + "img/br10.7b80fb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br10.jpg
// module id = GnDv
// module chunks = 0